<template>
  <div class="list_item">
    <div class="logo">
      <img
        src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo.png"
        alt
      />
    </div>
    <img
      class="banner"
      src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_list_item_0.jpg"
      alt
    />
    <div class="btn_box">
      <div
        :class="id == 1 || id == 3 ? 'btn btn2' : 'btn btn1'"
        v-for="(item, index) in list[id].child"
        :key="index"
        @click="goPage(item.id)"
      >
        <img class="btn_icon" :src="item.icon" alt />
        <div class="btn_name">
          <p>{{ item.name.slice(0, item.br) }}</p>
          <p>{{ item.name.slice(item.br) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mianZhen_list_item",
  data() {
    return {
      id: "",
      type: 1,
      list: [
        {
          title: "眼部护理",
          child: [
            {
              id: 0,
              name: "中胚层护理",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico0.png",
              br: 3
            },
            {
              id: 1,
              name: "仪器护理",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico1.png",
              br: 2
            },
            {
              id: 2,
              name: "居家护理",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/ico2.png",
              br: 2
            }
          ]
        },
        {
          title: "上睑",
          child: [
            {
              name: "松弛下垂",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_ico2.png",
              br: 0
            },
            {
              id: 6,
              name: "凹陷",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_ico1.png",
              br: 0
            }
          ]
        },
        {
          title: "下睑纹",
          child: [
            {
              id: 9,
              name: "动态纹",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_ico5.png",
              br: 0
            },
            {
              id: 10,
              name: "干纹",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_ico4.png",
              br: 0
            },
            {
              id: 11,
              name: "真性皱纹",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_ico3.png",
              br: 0
            }
          ]
        },
        {
          title: "眼袋",
          child: [
            {
              id: 14,
              name: "单一脂肪型",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_ico2.png",
              br: 0
            },
            {
              id: 15,
              name: "复合型",
              icon:
                "http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_ico1.png",
              br: 0
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.id = this.$route.query.id;
  },
  methods: {
    goPage(id) {
      if (id == undefined) {
        this.$router.push({ path: "/mianzheng/list/list_item1" });
        return;
      }
      this.$router.push({
        path: "/mianzheng/info",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.list_item {
  min-height: 100vh;
  background-image: url("https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/bgimg2.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  .logo {
    height: 1rem;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      pointer-events: none;
    }
  }
  .banner {
    width: 100%;
    margin-top: 0.4rem;
  }
  .btn_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.5rem;
    margin-top: 0.4rem;
    .btn {
      border-radius: 0.17rem;
      overflow: hidden;
      background: rgba(126, 13, 198, 0.5);
      border: 0.02rem solid rgba(255, 255, 255, 0.15);
      text-align: center;
      font-size: 0;
      padding: 0.4rem 0;
      user-select: none;
      &:active {
        background: rgba(126, 13, 198, 0.7);
        border: 0.02rem solid rgba(255, 255, 255, 0.2);
      }
      .btn_icon {
        width: 0.98rem;
        height: 0.98rem;
        pointer-events: none;
      }
      .btn_name {
        font-size: 0.36rem;
        color: #ffffff;
        margin-top: 0.4rem;
      }
    }
    .btn2 {
      width: 3.07rem;
    }
    .btn1 {
      width: 2.08rem;
    }
  }
}
</style>
